export default "__VITE_ASSET__4d72d541__"